var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 20.6895L16.086 15.0255C17.4471 13.3915 18.1258 11.2956 17.981 9.17392C17.8361 7.05222 16.8789 5.06804 15.3084 3.63413C13.7379 2.20023 11.675 1.427 9.54893 1.47531C7.42284 1.52362 5.39723 2.38974 3.89347 3.8935C2.38971 5.39726 1.52359 7.42288 1.47528 9.54896C1.42697 11.6751 2.2002 13.7379 3.6341 15.3084C5.06801 16.8789 7.05219 17.8362 9.17389 17.981C11.2956 18.1258 13.3914 17.4471 15.0255 16.086L20.6895 21.75L21.75 20.6895ZM2.99996 9.74999C2.99996 8.41497 3.39585 7.10993 4.13754 5.9999C4.87924 4.88986 5.93345 4.0247 7.16685 3.51381C8.40025 3.00292 9.75745 2.86924 11.0668 3.12969C12.3762 3.39014 13.5789 4.03302 14.5229 4.97702C15.4669 5.92103 16.1098 7.12376 16.3703 8.43314C16.6307 9.74251 16.497 11.0997 15.9862 12.3331C15.4753 13.5665 14.6101 14.6207 13.5001 15.3624C12.39 16.1041 11.085 16.5 9.74996 16.5C7.96036 16.498 6.24463 15.7862 4.97919 14.5208C3.71375 13.2553 3.00195 11.5396 2.99996 9.74999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonSearch);
export default __webpack_public_path__ + "static/media/commonSearch.2e971c3594c2b19b05059aa7e561a18e.svg";
export { ForwardRef as ReactComponent };